import axios from 'axios';

axios.interceptors.response.use(null, function(err) {
  if ( err.response.status === 401 && err.config.url.indexOf('login.json') === -1) {
    localStorage.removeItem('user');
    window.location = '/login';
  }
  return Promise.reject(err);
});